import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { Accnt } from '../accnt/Accnt';
import { createAppendix, IAppendixSnapshot } from '../appendix/Appendix';
import { createConclusion, IConclusionSnapshot } from '../conclusion/Conclusion';
import { createEtc, IEtcSnapshot } from '../etc/Etc';
import { Incident } from '../incident/Incident';
import { createInfraImage } from '../infra-image/InfraImage';
import { LoadBal } from '../load-bal/LoadBal';
import { Mngr } from '../mngr/Mngr';
import { Monitor } from '../monitor/Monitor';
import { NasVol } from '../nas-vol/NasVol';
import { Nks } from '../nks/Nks';
import { ServiceHist } from '../service-hist/ServiceHist';
import { Vm } from '../vm/Vm';

/**
 * # Report
 *
 * Report을 설명하세요.
 */
export const Report = types
  .model('Report')
  // --------------------------------------------------------------------------
  .props({
    reportSid: types.identifierNumber,
    reportNm: types.optional(types.string, ''),
    year: types.optional(types.string, ''),
    month: types.optional(types.string, ''),
    writeCmpny: types.optional(types.string, ''),
    writerNm: types.optional(types.string, ''),
    cnfirmNm: types.optional(types.string, ''),

    infraImage: createInfraImage(),

    appendix: types.maybeNull(createAppendix()),
    conclusion: types.maybeNull(createConclusion()),
    etc: types.maybeNull(createEtc()),

    accntInfos: types.optional(types.array(Accnt), []),
    incidents: types.optional(types.array(Incident), []),
    loadBals: types.optional(types.array(LoadBal), []),
    mngrInfos: types.optional(types.array(Mngr), []),
    // mngrs: types.optional(types.array(Mngr), []),
    monitorings: types.optional(types.array(Monitor), []),
    nasVols: types.optional(types.array(NasVol), []),
    nkss: types.optional(types.array(Nks), []),
    // servhists: types.optional(types.array(ServiceHist), []),
    serviceHists: types.optional(types.array(ServiceHist), []),
    vmhists: types.optional(types.array(Vm), []),

    pdfDownYn: types.optional(types.string, 'N'),

    insertDt: types.optional(types.number, 0),
    updateDt: types.optional(types.number, 0),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model report --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: IReport }) => {
      const newProps = { ...self, ...props } as IReport;
      (Object.keys(newProps) as TReportKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TReport = Instance<typeof Report>;
type TReportSnapshot = SnapshotOut<typeof Report>;

export interface IReport extends TReport {}
export type TReportKeys = keyof TReportSnapshot & string;
export interface IReportSnapshot extends TReportSnapshot {}
export const createReport = () => types.optional(Report, { reportSid: 0 } as TReport);

export interface ReportFilter {
  year?: string;
  type?: '' | '1H' | '2H' | '1Q' | '2Q' | '3Q' | '4Q';
  startDate?: number;
  endDate?: number;
  filterMode?: string; // 추가
  periodType?: string; // 추가
}

export interface ReportSaveDto {
  reportSid?: number;
  reportNm: string;
  year: string;
  month: string;
  writeCmpny: string;
  writerNm: string;
  cnfirmNm: string;

  conclusion?: IConclusionSnapshot | null;
  etc?: IEtcSnapshot | null;
  appendix?: IAppendixSnapshot | null;

  infraImage: { imageSid: number };

  serviceHists: { serviceHistSid: number }[];
  monitorings: { monitorSid: number }[];
  incidents: { incidentSid: number }[];
  mngrInfos: { mngrSid: number }[];

  accntInfos: { accntSid: number }[];
  vmhists: { vmSid: number }[];

  loadBals: { loadBalSid: number }[];
  nasVols: { nasVolSid: number }[];
  nkss: { clstrSid: number }[];
}
